export const formatCategoryName = (category: string): string => {
  const prefix = category.startsWith("grocery_list.category.")
    ? "grocery_list.category."
    : category.startsWith("grocery.category.")
      ? "grocery.category."
      : null;

  if (prefix) {
    const key = category.replace(prefix, "").replace(/_[0-9a-f]{6}$/i, "");
    return key
      .split("_")
      .map((word, index) => {
        if (index > 0 && ["and", "und"].includes(word.toLowerCase())) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }
  return category;
};
